import React from 'react';
import styled from 'styled-components';

export const VipsBackground = (): React.ReactElement => {
	const VipsBackground = styled.div`
		position: absolute;
		width: 100vw;
		height: 100%;
		z-index: -1;
		overflow: hidden;
		background-color: #4cc7f4;
		padding-bottom: 600px;
	`;

	const BlueEllipsis = styled.div`
		position: absolute;
		top: -10%;
		right: -10%;
		width: 72%;
		height: 123%;
		border-radius: 1153.454px;
		background: linear-gradient(180deg, rgba(47, 119, 242, 0.4) 0%, rgba(55, 110, 204, 0.4) 100%);
		filter: blur(50px);
	`;

	const GradientEllipsis = styled.div`
		position: absolute;
		bottom: -10%;
		left: -10%;
		width: 47%;
		height: 74%;
		border-radius: 697.522px;
		background: linear-gradient(180deg, rgba(123, 220, 255, 0.4) 0%, rgba(111, 216, 255, 0.18) 100%);
		filter: blur(100px);
	`;

	return (
		<VipsBackground className="vips-background">
			<BlueEllipsis className="vips-background__blue-ellipsis" />
			<GradientEllipsis className="vips-background__gradient-ellipsis" />
		</VipsBackground>
	);
};
